import { FormattedMessage } from 'react-intl';

import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { playerDetails } from 'lib/glossary';

import { PlayingStatusIcon } from './PlayingStatusIcon';

type Props = { starting: boolean };
export const PlayingStatus = ({ starting }: Props) => {
  return (
    <Horizontal center gap={0.5}>
      <PlayingStatusIcon starting={starting} width={12} />
      <LabelS>
        {starting ? (
          <FormattedMessage {...playerDetails.starting} />
        ) : (
          <FormattedMessage {...playerDetails.notStarting} />
        )}
      </LabelS>
    </Horizontal>
  );
};
